import { validate } from 'email-validator';
import { isNil } from 'lodash';

export function validateEmail(input: string): boolean {
  return validate(input);
}

export function validateEmails(input: string[] | null): boolean {
  if (isNil(input)) {
    return true;
  }
  return input.every(validateEmail);
}
